export default __webpack_public_path__ + "static/media/dp.0734b00f.png";